import * as React from "react";
import { updateCouponButtonPosition } from "./helpers";
import { debounce } from "debounce-decorator"
import { CouponButtonPosition } from "../../../../Typings";
import { DeviceDetect } from "sb-resp-lib";
type CreateCouponBtnProps = {
    label: string,
    count: number,
    sportId: string,
    onClick(sportId: string, ev: React.SyntheticEvent),
    parentRef: React.RefObject<HTMLDivElement>,
    cuponPosition: number,
    wrapEl: HTMLElement,
    tabletTopOffSet: number,
    deviceType: DeviceDetect
}
export class CreateCouponBtn extends React.PureComponent<CreateCouponBtnProps, {}> {
    couponBtnRef: React.RefObject<HTMLDivElement>;
    setDimensionsBound: EventListenerOrEventListenerObject;
    wrapperElement: HTMLElement | Window;
    topOffset: number;

    constructor(props) {
        super(props);
        this.couponBtnRef = React.createRef();
        this.setDimensionsBound = debounce(this.setDimensions, 10).bind(this);
        this.wrapperElement = window;
        this.topOffset = 0;
    }

    setDimensions() {
        const parent = this.props.parentRef.current;
        const child = this.couponBtnRef.current;
        if (child && parent) {
            updateCouponButtonPosition(child, parent, this.topOffset);
        }
    }

    componentDidMount() {
        if (this.props.cuponPosition === CouponButtonPosition.Fixed) {
            this.setDimensions();
            if (this.props.deviceType.isTablet) {
                this.wrapperElement = this.props.wrapEl
                this.topOffset = this.props.tabletTopOffSet
            }
            this.wrapperElement.addEventListener("resize", this.setDimensionsBound);
            this.wrapperElement.addEventListener("scroll", this.setDimensionsBound);
            // "btn-is-fixed";
        }
        // "btn-is-not-fixed";
    }

    componentWillUnmount() {
        this.wrapperElement.removeEventListener("resize", this.setDimensionsBound);
        this.wrapperElement.removeEventListener("scroll", this.setDimensionsBound);
    }

    render() {
        return (
            <div className="rj-league-list__coupon-btn-wrap" ref={this.couponBtnRef} data-uat="div-league-list-coupon">
                <button className="rj-league-list__coupon-btn-content" onClick={(e) => this.props.onClick(this.props.sportId, e)} data-uat="button-league-list-coupon">
                    {this.props.label} ({this.props.count})
                </button>
            </div>
        )
    }
}